import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface EpisodeListProps {
  drama: Drama;
}

export default function EpisodeList({ drama }: EpisodeListProps) {
  const episodes = Array.from({ length: drama.episodes }, (_, i) => i + 1);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <i className="ri-list-check-2 text-primary-500"></i>
          剧集列表
        </h2>
        <span className="text-sm text-foreground-600">
          更新至第 {drama.latestEpisode} 集 / 共 {drama.episodes} 集
        </span>
      </div>

      <div className="grid grid-cols-4 gap-2 sm:grid-cols-6 md:grid-cols-8 md:gap-3">
        {episodes.map((ep) => {
          const available = ep <= drama.latestEpisode;
          if (available) {
            return (
              <Link
                key={ep}
                to={`/play/${drama.id}/${ep}`}
                className="flex h-11 items-center justify-center rounded-md border border-background-300 bg-background-100 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-500 hover:text-background-50 cursor-pointer"
              >
                {ep}
              </Link>
            );
          }
          return (
            <span
              key={ep}
              className="flex h-11 cursor-not-allowed items-center justify-center rounded-md border border-dashed border-background-300 text-sm text-foreground-400"
              title="暂未更新"
            >
              {ep}
            </span>
          );
        })}
      </div>
    </section>
  );
}